import { useQuery } from '@tanstack/react-query';
import { fetchSparksSettings } from '@/services/sparks';

export function useSparksSettings(enabled = true) {
  return useQuery({
    queryKey: ['sparks-settings'],
    queryFn: fetchSparksSettings,
    staleTime: 5 * 60_000,
    enabled,
  });
}
